import { getWebAppLink, getSessionsLink, openSessionsLink } from '@landr/core';
import { Links } from '../enums/Links.es.js';

var getWebAppLinkLibraryOrMasteringPreview = function getWebAppLinkLibraryOrMasteringPreview(env, isLoggedOut) {
  var pathname = isLoggedOut ? "".concat(Links.Library, "/masteringPreview") : Links.Library;
  return getWebAppLink(env, pathname);
};
var getSessionsAboutLink = function getSessionsAboutLink(env) {
  return "".concat(getSessionsLink(env, '#about'));
};
var openSessionNewRoomLink = function openSessionNewRoomLink(env) {
  return openSessionsLink(env, '/rooms/new');
};

export { getSessionsAboutLink, getWebAppLinkLibraryOrMasteringPreview, openSessionNewRoomLink };
